module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label big-label"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Quel est votre diplôme le plus élevé ?")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.diplomas,
      "selected": _vm.diploma
    },
    on: {
      "change": function($event) {
        _vm.diploma = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label big-label"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("En tant qu'investisseur, vous vous estimez : ")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.levels,
      "selected": _vm.level
    },
    on: {
      "change": function($event) {
        _vm.level = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label big-label"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Depuis quand effectuez-vous des placements financiers ?")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.ages,
      "selected": _vm.age
    },
    on: {
      "change": function($event) {
        _vm.age = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input ctn-label big-label"
  }, [_c('label', {
    attrs: {
      "for": "montant"
    }
  }, [_vm._v("Le climat économique de votre pays dans 3 ans sera :")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.countries,
      "selected": _vm.country
    },
    on: {
      "change": function($event) {
        _vm.country = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuel type de produit connaissez-vous ? (plusieurs réponses possibles)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.products), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(_vm.product, tag),
        locked: _vm.isLocked(_vm.product, tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(_vm.product, tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tSur quels produits avez-vous investi ? (plusieurs réponses possibles)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.investedProducts), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(_vm.investedProduct, tag),
        locked: _vm.isLocked(_vm.investedProduct, tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(_vm.investedProduct, tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuels modes de gestion connaissez-vous ? (plusieurs réponses possibles)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.managements), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(_vm.management, tag),
        locked: _vm.isLocked(_vm.management, tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(_vm.management, tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b9c2234"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Knowledge.vue
// module id = 1094
// module chunks = 0